import React, { Component, createRef } from "react";
import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "datatables.net-buttons/js/dataTables.buttons.js";
import "datatables.net-buttons/js/buttons.colVis.js";
import "datatables.net-buttons/js/buttons.flash.js";
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.print.js";
import $ from "jquery";
import Modal from "react-responsive-modal";
import toast, { Toaster } from "react-hot-toast";
import "react-datetime/css/react-datetime.css";
import {
  getTicketSourceList,
  updateTicketSource,
} from "../../../models/_ticketSource";
import Breadcrumb from "../../Common/Breadcrumb";

export default class TicketSourceList extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      resetIsDefault: createRef(),
      filterLoading: false,
      editOpen: false,
      addLoading: false,
      currentlyOpenRecord: {},
      ticketSourceListObj: {},
      name: "",
    };
  }
  async componentWillMount() {}
  async componentDidUpdate() {}

  async componentDidMount() {
    var _ = this;
    $("#ticketSourceTable").on("click", ".editBtn", function () {
      const record = $(this).attr("data-recordId");
      _.editOpen(record);
    });
    const rows = await this.getData();
    this.renderDataTable(rows);
  }

  // rendering datatable jquery
  renderDataTable = (rows: any) => {
    const getPermissions: any = localStorage.getItem("permissions");
    const permissions = getPermissions || [];

    $(document).ready(function () {
      $("#ticketSourceTable").DataTable().destroy();
      let table = $("#ticketSourceTable").DataTable({
        data: rows,
        stateSave: true,
        columns: [
          {
            name: "index",
            render: function (data, type, row) {
              return row.id;
            },
          },
          {
            name: "name",
            render: function (data, type, row) {
              return row.name;
            },
          },
          {
            name: "action",
            render: function (data, type, row) {
              let returnData = "";
              if (permissions?.includes("update-ticket-source") === true) {
                returnData +=
                  '<div data-bs-toggle="tooltip" title="Click here to edit ticket source"><button class="btn btn-secondary btn editBtn p-2 px-4 m-1" data-recordId=\'' +
                  row.recordId +
                  "'><i class='fa fa-pencil' style='font-size:1rem;'></i></button></div>";
              }
              return returnData;
            },
          },
        ],
        pagingType: "full_numbers",
        pageLength: 20,
        processing: true,
        dom: "Bfrtip",
        destroy: true,
        lengthMenu: [
          [10, 20, 30, 50, -1],
          [10, 20, 30, 50, "All"],
        ],
        columnDefs: [
          {
            targets: 0,
            render: function (data, type, row, meta) {
              return type === "export" ? meta.row + 1 : data;
            },
          },
        ],
      });
      if (permissions?.includes("update-ticket-source") === false) {
        table.column(2).visible(false);
      }
      $(".dt-buttons").remove();
    });
  };

  // fetch data into datatable

  getData = async (isReset = false) => {
    const records = await getTicketSourceList();
    const rows = [];
    const ticketSourceListObj: any = {};
    let counter = 0;
    for (const record of records) {
      counter++;
      const tempRecord = {
        id: counter,
        recordId: record.id,
        name: record.name,
        record: record,
      };
      rows.push(tempRecord);
      ticketSourceListObj[record.id] = tempRecord;
    }

    this.setState({
      ticketSourceListObj: ticketSourceListObj,
    });
    return rows;
  };
  //edit ticket open
  editOpen = (recordId: any) => {
    const record = this.state.ticketSourceListObj[recordId];
    this.setState({
      name: record.name,
      currentlyOpenRecord: record.record,
      editOpen: true,
    });
  };
  editClose = () => {
    this.setState({
      currentlyOpenRecord: "",
      name: "",
      editOpen: false,
      loading: false,
    });
  };

  submitEdit = async (record: any) => {
    let hasErrors = false;
    if (this.state.name === "") {
      hasErrors = true;
      toast.error("Name is required!");
    }
    if (hasErrors) {
      return false;
    }
    this.setState({
      loading: true,
    });
    const updateData = {
      id: record.id,
      name: this.state.name,
    };
    const result = await updateTicketSource(updateData);

    if (result?.data?.data?.updateTicketSource) {
      toast.success("Ticket source updated successfully");
      this.setState({
        loading: false,
      });
      this.editClose();
      const rows = await this.getData();
      this.renderDataTable(rows);
    } else {
      this.setState({
        loading: false,
      });
      const messages = result?.data?.errors.map((e: any) => e.message);
      toast.error(messages.join(","));
    }
  };
  searchData = async () => {
    this.setState({
      addLoading: true,
    });
    const rows = await this.getData();
    this.renderDataTable(rows);
    this.setState({
      addLoading: false,
    });
    return false;
  };
  removeSearch = async () => {
    this.setState({
      filterLoading: true,
    });
    this.state.resetIsDefault.current.setValue("");
    const rows = await this.getData();
    this.renderDataTable(rows);
    this.setState({
      filterLoading: false,
      filterIsDefault: "",
    });
    return false;
  };
  render() {
    return (
      <div>
        <div id="kt_app_toolbar" className="app-toolbar py-2 pt-4">
          <div
            id="kt_app_toolbar_container"
            className="app-container container-xxl d-block d-lg-flex d-md-flex d-xl-flex flex-stack px-3"
            style={{ maxWidth: "100%" }}
          >
            <div className="page-title d-flex flex-column justify-content-center flex-wrap">
              <h1 className="page-heading d-flex text-dark fw-bold fs-1 flex-column justify-content-center my-0">
                Ticket Sources List
              </h1>
            </div>
            <div className="d-flex align-items-center gap-2 gap-lg-3">
                <Breadcrumb
                links={[
                  { label: "Home", href: "/dashboard", isActive: false },
                  { label: "Ticket Sources List", href: "", isActive: true },
                ]}
                />
            </div>
          </div>
        </div>

        <div className="card mt-9">
          <div className="card-body w-100 p-lg-7 p-md-7 p-5">
            <div className="row">
              <div className="col-12">
                <div className="table-responsive p-0 pb-2 fs-6" id="data-table">
                  <table
                    id="ticketSourceTable"
                    className="table align-items-center display justify-content-center mb-0 w-100"
                  >
                    <thead>
                      <tr>
                        <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                          Sr No.
                        </th>
                        <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                          Name
                        </th>
                        <th className="text-capitalize font-weight-bolder opacity-7 ps-2">
                          Action
                        </th>
                      </tr>
                    </thead>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <Modal
            open={this.state.editOpen}
            onClose={this.editClose}
            role="modal"
            center
            classNames={{
              root: "content-wrapper",
            }}
          >
            <div className="modal-header p-2 pb-4 mb-4">
              <h4 className="modal-title fs-1">Edit Ticket Source </h4>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-12 mt-2 pt-2 w-100">
                  <label className="form-label fs-4 required fw-bold">
                    Name
                  </label>
                  <input
                    className="form-control"
                    name="name"
                    id="name"
                    autoComplete="off"
                    defaultValue={this.state.name}
                    onChange={(event: any) => {
                      this.setState({
                        name: event.target.value,
                      });
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer mt-6 p-0 justify-content-start">
              <button
                type="submit"
                onClick={() => {
                  return this.submitEdit(this.state.currentlyOpenRecord);
                }}
                className="btn btn-primary me-4 fs-4 p-0 px-6 py-3 mt-6"
              >
                {this.state.loading && (
                  <span
                    className="indicator-progress"
                    style={{ display: "block" }}
                  >
                    Please Wait..
                    <span className="spinner-border spinner-border-sm align-middle ms-3 mb-1"></span>
                  </span>
                )}
                {!this.state.loading && (
                  <span className="indicator-label">UPDATE</span>
                )}
              </button>
            </div>
          </Modal>
          <Toaster
            position="bottom-left"
            reverseOrder={false}
            gutter={8}
            containerClassName=""
            containerStyle={{}}
            toastOptions={{
              className: "",
              duration: 3000,
            }}
          />
        </div>
      </div>
    );
  }
}
